<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleGestorCompras || hasRoleComprador"
             color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
             link to="/fornecedores/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Fornecedor
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um fornecedor"
                      class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorCompras', 'hasRoleComprador']),
    searchText: {
      get() {
        return this.$store.getters['listagemFornecedores/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemFornecedores/searchText', searchText);
      },
    },
  },
};
</script>
